import React, { useState } from 'react';
import './App.css';
import './SubmittedSite.css';
import ApplicationForm from './components/applicationform/ApplicationForm';
import { FormData } from './components/Types';
import nemoraLogo from './images/nemora-logo.png';
import { translations } from './components/translations';

import Navbar from './components/navbar/Navbar';

import {
    initializeApp
} from "firebase/app";
import {
    getDatabase,
    ref as dbRef,
    push
} from "firebase/database";
import {
    getStorage,
    ref as storageRef,
    uploadBytes,
    getDownloadURL
} from "firebase/storage";
import Footer from './components/footer/Footer';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const storage = getStorage(app);

const App: React.FC = () => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [language, setLanguage] = useState<'fi' | 'en'>('fi');

    const handleFormSubmit = async (data: FormData) => {

        const resumeRef = storageRef(storage, 'resumes/' + data.resume?.name);
        const coverLetterRef = storageRef(storage, 'coverLetters/' + data.coverLetter?.name);

        let resumeURL = '';
        let coverLetterURL = '';

        if (data.resume) {
            try {
                await uploadBytes(resumeRef, data.resume);
                resumeURL = await getDownloadURL(resumeRef);
            } catch (error) {
                console.error("Error uploading resume:", error);
            }
        }

        if (data.coverLetter) {
            try {
                await uploadBytes(coverLetterRef, data.coverLetter);
                coverLetterURL = await getDownloadURL(coverLetterRef);
            } catch (error) {
                console.error("Error uploading cover letter:", error);
            }
        }

        const finalData = {
            ...data,
            resume: resumeURL,
            coverLetter: coverLetterURL,
        };

        const applicationsRef = dbRef(db, 'applications');
        push(applicationsRef, finalData)
            .then(() => {
                setIsSubmitted(true);
                window.scrollTo(0, 0);
            })
            .catch((error) => {
                console.log('Error sending data to Firebase:', error);
            });
    };

    if (isSubmitted) {
        return (
            <>
                <Navbar language={language} onToggle={setLanguage} />
                <div className='submitted'>
                    <div className='form__logo__submitted'>
                        <img src={nemoraLogo} alt="Nemora Logo" style={{ width: '100%', height: '100%' }} />
                    </div>
                    <div className="submitted-container">
                        <div className="submitted-messages">
                            <h2>{translations[language].submittedHeader}</h2>
                            <h2>{translations[language].submittedHeaderTwo}</h2>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <div id='navbar' className='App'>
            <Navbar language={language} onToggle={setLanguage} />
            <div className="Form">
                <div className='form__logo'>
                    <img src={nemoraLogo} alt="Nemora Logo" style={{ width: '100%', height: '100%' }} />
                </div>
                <ApplicationForm onSubmit={handleFormSubmit} language={language} />
            </div>
            <div className='footer'>
                <Footer />
            </div>
        </div>
    );
};

export default App;
